<template>
  <subAccountCommonDialog class="sub-account-add-dialog" :visible.sync="visible" title="添加子账号" @clickCancel="clickCancel" @clickConfirm="clickConfirm">
    <template v-slot:dialogContent>
      <span class="title">添加数量：</span>
      <el-radio class="number-radio" v-model="radioValue" :label="1">1个</el-radio>
      <el-radio class="number-radio" v-model="radioValue" :label="3">3个</el-radio>
      <el-radio class="number-radio" v-model="radioValue" :label="5">5个</el-radio>
      <el-radio class="other-radio" v-model="radioValue" :label="-1">其他</el-radio>
      <el-input-number class="other-input" v-model="inputValue" :controls="false" :precision="0" size="mini" placeholder="" :min="1" :max="99" @focus="inputFocus"></el-input-number>个
    </template>
  </subAccountCommonDialog>
</template>
<script>
import subAccountCommonDialog from './subAccountCommonDialog.vue'
export default {
  name: 'subAccountAddDialog',
  props: ['visible'],
  data() {
    return {
      radioValue: 1,
      inputValue: undefined
    }
  },
  methods: {
    clickCancel() {
      this.$emit('clickCancel')
    },
    clickConfirm() {
      const value = this.radioValue === -1 ? (this.inputValue ? this.inputValue : 1) : this.radioValue
      this.$emit('clickConfirm', value)
    },
    inputFocus() {
      this.radioValue = -1
    }
  },
  components: {
    subAccountCommonDialog
  }
}
</script>
<style lang="scss" scoped>
.sub-account-add-dialog {
  .title {
    color: #000;
  }
  .number-radio {
    margin-right: 16px;
  }
  .other-radio {
    margin-right: 4px;
  }
  .other-input {
    width: 30px;
    height: 22px;
    /deep/ .el-input {
      .el-input__inner {
        padding: 0 !important;
        height: 22px;
      }
    }
  }
}
</style>
